import SelectableItem from 'components/SelectableItemsList/SelectableItem'

const DisplayCategoryLabel = ({
  selectedItemsUuids,
  item,
  handleChangeCheckbox,
}) => {
  const checked = selectedItemsUuids?.includes(item.uuid)

  const handleChange = (itemUuid) => {
    if (checked) {
      handleChangeCheckbox(
        selectedItemsUuids?.filter(
          (selectedUuid) => selectedUuid !== itemUuid
        )
      )
    } else {
      handleChangeCheckbox([...selectedItemsUuids, itemUuid])
    }
  }

  return (
    <SelectableItem
      key={item.uuid}
      label={item.name}
      checked={checked}
      handleChange={() => handleChange(item?.uuid)}
    />
  )
}

export default DisplayCategoryLabel
